import { app_subscription_hdr_RowClass } from '../../dbschema/app_subscription_hdr.model';
import { bl_applet_catalog_hdr_RowClass } from '../../dbschema/bl_applet_catalog_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class TenantSubscriptionModel extends BaseContainerModel {
  app_subscription_hdr: app_subscription_hdr_RowClass = new app_subscription_hdr_RowClass();
  app_subscription_hdrs: app_subscription_hdr_RowClass[] = [];
  bl_applet_catalog_hdrs: bl_applet_catalog_hdr_RowClass[] = [];
}
